import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import debounce from 'lodash.debounce';

import showRow from './components/ShowRow';
import videoRow from './components/VideoRow';
import PageLoader from "./components/PageLoader";
import { event } from "./helpers";

let StyledApp = styled('div')`
  & {
    padding: 16px 0 32px;
  
    .parasol {
      line-height: 0;
    }
    
    .parasol .parasol-cap {
      display: none;
    }
  
    .parasol .parasol-cap.parasol-control {
      display: inline-block;
    }
  
    .parasol:hover .parasol-control:after {
      opacity: 1;
      transition: color 400ms cubic-bezier(0.5, 0, 0.1, 1), opacity 400ms ease 400ms;
    }
    
    .parasol-control {
      margin: 0;
      background: rgba(0, 0, 0, 0.75);
      color: #fff;
      font-family: 'Font Awesome 5 Pro';
      font-style: normal;
      font-weight: 300;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      line-height: 1;
    }
    
    .parasol-control:hover, .parasol-control:focus {
      background: rgba(0, 0, 0, 0.75);
    }
    
    .parasol-control:after {
      opacity: 0;
    }
    
    .parasol-control:focus:after {
      opacity: 1;
    }
    
    .parasol-control:hover:after {
      color: #05c789;
    }
    
    .parasol-control:after {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: color 400ms cubic-bezier(0.5, 0, 0.1, 1), opacity 400ms ease;
    }
    
    .parasol-control.parasol-cap-left {
      padding-right: 0;
    }
    
    .parasol-control.parasol-cap-right {
      padding-left: 0;
    }
    
    .parasol-control.parasol-cap-left:after {
      content: "\\f104";
    }
    
    .parasol-control.parasol-cap-right:after {
      content: "\\f105";
    }
    
    .parasol-container .view-0 {
      z-index: 3;
    }
    
    .parasol-container .view-1 {
      z-index: 3;
    }
    
    .parasol-container .view-2 {
      z-index: 3;
    }
    
    .parasol-container .view-3 {
      z-index: 3;
    }
    
    .parasol-container .view-4 {
      z-index: 3;
    }
    
    .parasol-container .view-5 {
      z-index: 3;
    }
    
    .parasol-container .view-6 {
      z-index: 3;
    }
    
    .parasol-container .view-7 {
      z-index: 3;
    }
    
    .parasol-container .view-8 {
      z-index: 3;
    }
    
    style {
      display: none !important;
    }
  }
`;

function chunk(array, size) {
  let chunks = [];

  let index = 0;
  for (let index = 0; index < array.length; index += size) {
    chunks.push(array.slice(index, size + index));
  }

  return chunks;
}

function parseTitleVariant(variant) {
  switch (variant) {
    case 'episode':
      return 'EPISODE';
    case 'details':
      return 'DETAILS';
    default:
      return 'SHOW';
  }
}

export class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      breakpoints: props.breakpoints || [[1500, 6], [1200, 5], [900, 4], [600, 3], [0, 2]],
      rows: chunk(props.rows.map(row => {
        let rowBuilder = row[2] && row[2].view === 'show' ? showRow : videoRow;

        return [
          row[0],
          rowBuilder(row[1]),
          {
            miniTitle: parseTitleVariant(row[2] && row[2].titleVariant || 'show')
          }
        ]
      }), 4),
      keyboardInteraction: false,
      mobileView: typeof props.mobileView !== 'undefined' ? props.mobileView : false,
      pages: 1
    };

    this.detectMobileView = this.detectMobileView.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', debounce(this.detectMobileView, 1000));
    window.addEventListener('keydown', this.enableKeyboardHighlights.bind(this));
    window.addEventListener('error', (event) => 
    {
      // If an image 404s, change to a default image
      if (event.target.tagName === 'IMG')
      {
        event.target.src = `/content/themes/tpt/dist/images/default-post-image-600.jpg`;
        event.target.srcset = '/content/themes/tpt/dist/images/default-post-image-600.jpg 700w, /content/themes/tpt/dist/images/default-post-image-600.jpg 550w, /content/themes/tpt/dist/images/default-post-image-600.jpg 400w, /content/themes/tpt/dist/images/default-post-image-600.jpg 100w';
      }
    }, true);
  }

  enableKeyboardHighlights() {
    if (!this.state.keyboardInteraction) {
      this.setState(() => {
        return { keyboardInteraction: true };
      });
    }
  }

  detectMobileView() {
    if (window.outerWidth < 640) {
      if (this.state.mobileView === false) {
        this.setState(() => {
          return { mobileView: true };
        });
      }
    } else if (this.state.mobileView === true) {
      this.setState(() => {
        return { mobileView: false };
      });
    }
  }

  addPage() {
    this.setState((prevState) => {
      let pages = Math.min(prevState.pages + 1, this.state.rows.length);
      // event('LoadRows')(pages);
      return { pages };
    });
  }

  styles() {
    return `
      
    `;
  }

  render() {
    let rows = [];

    for (let i = 0; i < this.state.pages; i++) {
      if (this.state.rows[i]) {
        rows = rows.concat(this.state.rows[i]);
      }
    }

    let classes = ['home-rows'];

    if (!this.state.keyboardInteraction) {
      classes.push('home-rows-no-keyboard');
    }

    return <StyledApp className={classes.join('')}>
      {
        rows.map(ep => {
          let Row = ep[1];
          return <Row
            key={ep[0]}
            title={ep[0]}
            breakpoints={this.state.breakpoints}
            mobileView={this.state.mobileView}
            itemProps={ep[2]}
          />;
        })
      }
      {this.state.pages < this.state.rows.length && <PageLoader listener={this.addPage.bind(this)} threshold={200} />}
    </StyledApp>;
  }
}